import React from 'react'
import useEffectOnce from 'hooks/useEffectOnce'
import useShowError from 'hooks/useShowError'
import axios from 'providers/axios'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import useRedirectIfLoggedIn from 'hooks/useRedirectIfLoggedIn'
import SignUpProductMaven from 'components/pages/signup/SignUpProductMaven'
import SignUpProduct from 'components/pages/signup/SignUpProduct'
import FullScreenLoading from 'components/ui/FullScreenLoading'
import { Product } from 'type/types'
import { URL_APP } from 'helpers/config'
type ProductData = Pick<Product, 'id' | 'name' | 'nameFile' | 'visibility' | 'offer' | 'offer2'>

const SignUpProductPage: React.FC = () => {
  const params = useParams()

  const [searchParams] = useSearchParams()

  const { loading } = useRedirectIfLoggedIn(`${URL_APP}/subscribe/${params.productId}?${searchParams.toString()}`)

  const showError = useShowError()
  const navigate = useNavigate()

  const [product, setProduct] = React.useState<ProductData | null>(null)

  useEffectOnce(() => {
    const fetchProduct = async () => {
      try {
        const { data } = await axios.get<ProductData>(`/sign-up/product/${params.productId}`)
        if (!data) throw new Error('Product not found')
        setProduct(data)
      } catch (error) {
        showError(error)
        navigate('/signup')
      }
    }

    fetchProduct()
  })

  if (!product || loading) return <FullScreenLoading />

  if (product.visibility === 'MAVEN') return <SignUpProductMaven product={product} />

  return <SignUpProduct product={product} />
}

export default SignUpProductPage
